import AuthService from '../services/auth.service';
import i18n from '../i18n';

import { router } from '../router';

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user ?
  { status: { loggedIn: true }, user } :
  { status: { loggedIn: false }, user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, user) {
      return AuthService.login(user).then(
        (user) => {
          if(user != "SOMEONE_IS_LOGGED"){
            commit('loginSuccess', user);
          }
          return Promise.resolve(user);
        },
        (error) => {
          commit('loginFailure');
          return Promise.reject(error);
        },
      );
    },
    firstLogin({ commit }) {
      const user = JSON.parse(localStorage.getItem('user'));
      user.numLogins = 1;
      localStorage.setItem('user', JSON.stringify(user));
      commit('firstLoginSuccess');
    },
    connectAs({commit},user){
      localStorage.setItem('impostor', localStorage.getItem("user"));
      localStorage.setItem('user',JSON.stringify(user));
      commit('connectAsSuccess', user);
    },
    quitImpostor({commit}){
      let impostor = JSON.parse(localStorage.getItem("impostor"))
      if(impostor.language){
        i18n.locale = impostor.language;
      }
      localStorage.setItem('user',localStorage.getItem("impostor"));
      localStorage.removeItem('impostor');
      commit('quitImpostorSuccess',impostor);
    },
    async logout({ commit,dispatch }) {
      await AuthService.logout();
      //hold redirect path before clear local storage
      let redirectPath = localStorage.getItem("redirectPath");
      localStorage.clear();
      if(redirectPath && redirectPath != 'null'){
        //put redirect path after clear local storage
        localStorage.setItem("redirectPath",redirectPath);
      }
      this.dispatch("clearGlobal");
      router.push("/login");
      commit('logout');
    },
    register({ commit }, user) {
      return AuthService.register(user).then(
        (response) => {
          commit('registerSuccess');
          return Promise.resolve(response.data);
        },
        (error) => {
          commit('registerFailure');
          return Promise.reject(error);
        },
      );
    },
    connectShareAs({commit},user){
      user.external = true;
      localStorage.setItem('user',JSON.stringify(user));
      commit('connectShareAsSuccess', user);
    },
    quitShareAs({commit}){
      localStorage.removeItem('user');
      commit('quitShareAsSuccess');
    },
    setLanguage({ commit }, language) {
      i18n.locale = language;
      commit('setLanguage', language);
    },
    setCurrency({ commit }, currencyCode) {
      commit('setCurrency', currencyCode);
    },
    setDarkmode({ commit }, darkMode) {
      commit('setDarkmode', darkMode);
    },
    setMediaMode({commit},mediaMode){
      commit('setMediaMode', mediaMode);
    },
    setFieldColor({commit},fieldColorCode){
      commit('setFieldColor', fieldColorCode);
    },
    setDefaultVisualization({commit},defaultVisualization){
      commit('setDefaultVisualization', defaultVisualization);
    },
    setLastSearch({commit},lastSearch){
      commit('setLastSearch',lastSearch);
    },
    setShowTour({commit}, showTour){
      commit('setShowTour', showTour);
    },
    setFirstName({commit}, firstName){
      commit('setFirstName', firstName);
    },
    setLastName({commit}, lastName){
      commit('setLastName', lastName);
    },
    setFieldPositionCodeId({commit},fieldPositionCodeId){
      commit('setFieldPositionCodeId', fieldPositionCodeId);
    },
    setFieldLayoutId({commit},fieldLayoutId){
      commit('setFieldLayoutId', fieldLayoutId);
    },
    setRatingFormatId({commit}, ratingFormatId){
      commit('setRatingFormatId', ratingFormatId);
    },
    setShowMediaMode({commit}, showMediaMode){
      commit('setShowMediaMode', showMediaMode);
    }
  },
  // navigator.language and navigator.userLanguage could be "es-ES" or "es" that's why need to split by -
  getters: {
    language: state => {
      let defaultLang = "en";
      let navigatorLanguage = navigator.language.split("-")[0] || navigator.userLanguage.split("-")[0];
      let language = _.get(state,'user.language');
      return language ? language : (navigatorLanguage ? navigatorLanguage : defaultLang);
    },
    impostor: state => {
      return state.impostor;
    },
    currency: state => {
      let defaultCurreny = "EUR";
      let currency = _.get(state,'user.currency');
      return currency ? currency : defaultCurreny;
    },
    fieldColor: state => {
      let defaultFieldColor = "green";
      let fieldColor = _.get(state,'user.fieldColor');
      return fieldColor ? fieldColor : defaultFieldColor;
    },
    fieldLayout: state => {
      let defaultFieldLayout = 1;
      let fieldLayout = _.get(state,'user.fieldLayoutId');
      return fieldLayout ? fieldLayout : defaultFieldLayout;
    },
    defaultVisualization: state => {
      let visualizationByDefault = "radar";
      let defaultVisualization = _.get(state,'user.defaultVisualization');
      return defaultVisualization ? defaultVisualization : visualizationByDefault;
    },
    fieldPositionCodeId: state => {
      let defaultFieldPositionCodeId = 1;
      let fieldPositionCodeId = _.get(state,'user.fieldPositionCodeId');
      return fieldPositionCodeId ? fieldPositionCodeId : defaultFieldPositionCodeId;
    },
    ratingFormatId: state => {
      let defaultRatingFormatId = 1;
      let ratingFormatId = _.get(state,'user.ratingFormatId');
      return ratingFormatId ? ratingFormatId : defaultRatingFormatId;
    },
    showMediaMode: state => {
      let defaultShowMediaMode = false;
      let showMediaMode = _.get(state,'user.showMediaMode');
      return showMediaMode ? showMediaMode : defaultShowMediaMode;
    },
    
  },
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    firstLoginSuccess(state) {
      state.user.numLogins = 1;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    connectAsSuccess(state, user) {
      state.status.loggedIn = true;
      state.impostor = state.user;
      state.user = user;
    },
    quitImpostorSuccess(state,impostor){
      state.status.loggedIn = true;
      state.impostor = null;
      state.user = impostor;
    },
    connectShareAsSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    quitShareAsSuccess(state){
      state.status.loggedIn = false;
      state.user = null;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    },
    setLanguage(state, language) {
      if(state.user){
        state.user.language = language;
      }
    },
    setDarkmode(state, darkMode) {
      if(state.user){
        state.user.darkMode = darkMode;
      }
    },
    setMediaMode(state, mediaMode) {
      if(state.user){
        state.user.mediaMode = mediaMode;
      }
    },
    setCurrency(state, currencyCode) {
      if(state.user){
        state.user.currency = currencyCode;
      }
    },
    setFieldColor(state, fieldColorCode) {
      if(state.user){
        state.user.fieldColor = fieldColorCode;
      }
    },
    setDefaultVisualization(state, defaultVisualization) {
      if(state.user){
        state.user.defaultVisualization = defaultVisualization;
      }
    },
    setLastSearch(state,lastSearch){
      state.lastSearch = lastSearch;
    },
    setShowTour(state, showTour){
      if(state.user){
        state.user.showTour = showTour;
      }
    },
    setFirstName(state, firstName){
      if(state.user){
        state.user.firstName = firstName;
      }
    },
    setLastName(state, lastName){
      if(state.user){
        state.user.lastName = lastName;
      }
    },
    setFieldPositionCodeId(state, fieldPositionCodeId) {
      if(state.user){
        state.user.fieldPositionCodeId = fieldPositionCodeId;
      }
    },
    setFieldLayoutId(state, fieldLayoutId) {
      if(state.user){
        state.user.fieldLayoutId = fieldLayoutId;
      }
    },
    setRatingFormatId(state, ratingFormatId) {
      if(state.user){
        state.user.ratingFormatId = ratingFormatId;
      }
    },
    setShowMediaMode(state, showMediaMode) {
      if(state.user){
        state.user.showMediaMode = showMediaMode;
      }
    },
  },
};

export default auth;



// WEBPACK FOOTER //
// ./src/store/auth.module.js